<div class="flex flex-column w-full h-full align-content-between">
  <div class="flex mb-4 gap-2 w-full">
    <toolbar class="w-full" title="Validations"></toolbar>
  </div>
  <div class="">
    <dynamic-table [headers]="columns" [data]="validations" [pageParams]="pageable"
                   [actions]="actions" (paginate)="onPageChange($event)"></dynamic-table>
  </div>
</div>
